var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgE3Tree(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.42 19.11a5.58 5.58 0 00-7.22-5 8.19 8.19 0 00-15.93 0 5.58 5.58 0 00-7.22 5 9.55 9.55 0 00.18 18.39L36 52.25V65H26v4h24v-4H40V52.75l13.2-15.24a9.55 9.55 0 00.22-18.4zM38 48.3l-9.13-10.54c2 1.41 5.36 2.33 9.17 2.33a16.94 16.94 0 009-2.2L38 48.3z",
    fill: "currentColor"
  })));
}
export default __webpack_public_path__ + "static/media/E3_Tree.0612459e.svg";
export { SvgE3Tree as ReactComponent };